import { getSchema, MergeField, MergeSchema } from '../../decorators';
import { ActivityEntityName, ActivityKind } from '../../../../entities';

@MergeSchema({
    entity: ActivityEntityName.Activity,
    name: 'ActivityMergeSchema',
})
export class ActivityMergeData {
    @MergeField()
    note: string;

    @MergeField()
    createdBy: string;

    @MergeField()
    createdDate: string;

    // @MergeField()
    // attachments: AttachmentMergeData[];

    @MergeField({
        arraySchemaName: 'AttachmentMergeSchema',
        ignoreFields: ['thumbnail', 'shared', 'tags']
    })
    attachments: AttachmentMergeData[] = [];

    kind: ActivityKind;
}

export const ActivityMergeSchema = getSchema(ActivityMergeData);

@MergeSchema({
    entity: ActivityEntityName.Attachment,
    name: 'AttachmentMergeSchema',
})
export class AttachmentMergeData {
    @MergeField()
    title: string;

    @MergeField()
    path: string;

    @MergeField()
    thumbnail: string;

    @MergeField()
    type: string;

    @MergeField({
        hidden: true
    })
    data: string;

    @MergeField()
    shared?: string;

    @MergeField()
    tags?: string;
}

export const AttachmentMergeSchema = getSchema(AttachmentMergeData);

@MergeSchema({
    entity: ActivityEntityName.Attachment,
    name: 'AttachmentsMergeSchema',
})
export class AttachmentsMergeData {
    @MergeField({
        arraySchemaName: 'AttachmentMergeSchema',
        ignoreFields: ['thumbnail']
    })
    attachments: AttachmentMergeData[] = [];
}

export const AttachmentsMergeSchema = getSchema(AttachmentsMergeData);